import carousel from '@/js/util/symbols/carousel'

export default {
  inject: { carousel },
  props: {
    // timer amount
    timer: {
      type: Number,
      default: null,
    },
    direction: {
      type: String,
      required: true,
      validator: direction => [
        'next',
        'previous',
      ].includes(direction),
    },
  },

  data() {
    return {
      carouselTimer: undefined,
    }
  },

  created() {
    this.carousel.$emit('create:buttons', this)
  },

  watch: {
    'carousel.animationState': 'handleStateChange',
  },

  methods: {
    emitCarouselEvent(...events) {
      this.carousel.$emit(...events)
    },
    setsCarouselDirection() {
      this.emitCarouselEvent('carousel:direction', this)
      this.setsTimer(true)
    },
    setsTimer(animationState) {
      if (this.timer === null) {
        return
      }
      this.emitCarouselEvent('animation:state', animationState)
    },
    handleStateChange(change) {
      if (change) {
        this.carouselTimer = setTimeout(() => this.setsTimer(false), this.timer)
        return
      }
      clearTimeout(this.carouselTimer)
    },

    handleKeyUpevent(event) {
      const { direction } = this
      const eventToEmit = {
        ArrowLeft: direction,
        ArrowRight: direction,
      }[event.key]

      if (!eventToEmit) {
        return
      }

      event.preventDefault()
      this.setsCarouselDirection(eventToEmit)
    },
  },
  render(createElement) {
    const elementData = {
      attrs: { disabled: this.carousel.animationState },
      on: {
        keyup: this.handleKeyUpevent,
        click: this.setsCarouselDirection,
      },
    }

    return createElement('button', elementData, this.$slots.default)
  },
}




// WEBPACK FOOTER //
// ./src/js/components/carousel/CarouselContainerButton.js